import { type RefObject, useEffect, useRef } from 'react'

import { useDeviceDetectorContext } from '../../../../device-detector'

import { type ScrollToElement } from './useScrollElementIntoView'

export const useMobileScrollAttributeIntoViewOnMount = ({
  attributeElement,
  isVariantSelected,
  onScrollIntoView,
}: {
  attributeElement: RefObject<HTMLElement | null>
  isVariantSelected: boolean
  onScrollIntoView?: ScrollToElement
}): void => {
  const { isMobile } = useDeviceDetectorContext()
  const selectedElementRef = useRef(isVariantSelected)

  useEffect(() => {
    if (selectedElementRef.current && isMobile) {
      onScrollIntoView?.(attributeElement)
    }
  }, [attributeElement, isMobile, selectedElementRef, onScrollIntoView])
}
